// 韩语配置
export default {
  title: 'MLB 클러치 히트 베이스볼',
  pageMainId: '2', // 语言对应的parentId
  iconTextShow: '지금 바로 다운로드！',
  bannerId: '8',
  downLinkArea: {
    apple: 'https://app.adjust.com/1crn00p3?campaign=iOSbutton',
    google: 'https://app.adjust.com/1cylwz8b?campaign=button_GP'
  },
  menu: [ // 菜单项配置
    {id: 'home',label: '홈페이지'},
    // {id: 'news',label: '뉴스'},
    {id: 'feature',label: '게임 특징'},
    {id: 'activity',label: '이벤트'},
  ],
  page2: {
    title: '뉴스',
    tabs: [
      {id: 'all',label: '전부'},
      {id: 'maintain',label: '점검'},
      {id: 'announcement',label: '공지'},
      {id: 'activity',label: '이벤트'},
    ],
    tabLib: {
      all: '12',
      maintain: '17',
      announcement: '18',
      activity: '19'
    },
    tabLibColor: {
      17: '#268044',
      18: '#b30000',
      19: '#409EFF'
    },
    tabTagLib: {
      17: '점검',
      18: '공지',
      19: '이벤트'
    }
  },
  page3: [
    {id:'1',title: "야구의 본질",content: '전세계 유저들과 투타 대결을 펼치고, 짜릿한 손맛을 느껴보세요!',img: 'page3Banner1'},
    {id:'2',title: "스타 선수 육성",content: '스킬, 훈련, 승급 등 풍부한 육성 시스템을 이용하여 나만의 슈퍼스타를 만들어보세요!',img: 'page3Banner2'},
    {id:'3',title: "다양한 게임 모드",content: '다양한 이벤트에 참여하시면, 즐거운 야구 경험과 함께 푸짐한 보상도 준비되어 있습니다!',img: 'page3Banner3'},
  ],
  page4: {
    title: '이벤트 정보',
    getCardId: 12 // 拉取card时传的id
  },
  pageBottom: {
    logo: '', // 底部展示的logo
    ruleList: [
      {id: '1',label: '서비스 약관',url:'https://www.wildcaly.com/ToSKr.html'},
      {id: '2',label: '개인정보처리방침',url:'https://www.wildcaly.com/privacypolicyKr.html'},
    ],
    iconAndLink: [ // 图片和跳转
      {id: 'faceBook',imgName: 'faceBook',url: 'https://www.facebook.com/profile.php?id=61555540829232'},
      {id: 'email',imgName: 'email',url: 'mailto:chbservice@wildcaly.com'},
      {id: 'naverGame',imgName: 'naverGame',url: 'https://game.naver.com/lounge/MLB_Clutch_Hit_Baseball'},
    ]
  },
}
